import { Component } from '@angular/core';
import { Appointment } from './appointment';
import { UtilityModule } from '../../Utility/utility.module';
import { FormsModule } from '@angular/forms';
import { AppointmentService } from './appointment.service';
import { AppointmentPickerPropertiesService } from '../../appointment-picker-properties.service';
import { AppointmentType } from './appointment-type';
import { ModalService } from '../../modal/modal.service';
import { CancelAppointment } from './cancel-appointment.component';
import { AppointmentPickerComponent } from '../../appointment-picker/appointment-picker.component';
import { CustomRadioButtonComponent } from '../../Utility/custom-radio-button/custom-radio-button.component';
import { Router, ParamMap, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-appointment',
    imports: [
    UtilityModule,
    AppointmentPickerComponent,
    // CustomRadioButtonComponent,
    FormsModule
],
    templateUrl: './appointment.component.html',
    styleUrl: './appointment.component.scss'
})
export class AppointmentComponent {
  appointment: Appointment | null = null
  appointmentSearch: string = ''
  appointmentSearchSite: string = ''
  appointmentSearchTranslator: string = ''
  appointmentType: string | null = null
  appointments: Appointment[] = []
  appointmentTypes: AppointmentType[] = []
  cancelling = false;
  submittingReschedule = false;
  viewingAppointmentId = 0
  isLoading = true
  cancelledButtons = [
    {label: "Display Canceled Appointments", value: "1"},
    {label: "Don't display Canceled Appointments", value: "0"},
  ]
  displayCanceled = false
  displayComplete = false

  constructor(private appointmentService: AppointmentService, 
    private appointmentPickerProperties: AppointmentPickerPropertiesService,
    private modalService: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    // fixes rerender when using this.router.navigate()
    // but breaks forward/back buttons...this should be a hard thing to do. 
    // this.router.routeReuseStrategy.shouldReuseRoute = () => true;
  };

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.viewingAppointmentId = Number(params.get('appointmentId'))
    })
    this.getAppointments()
    this.getAppointmentTypes()
    // this.loadCancelModel()
  }
  ngOnDestroy() {
  }
  getAppointmentTypes() {
    if (this.appointmentService.appointmentTypes.length) {
      this.appointmentTypes = this.appointmentService.appointmentTypes
    }
    else {
      this.appointmentService.getAppointmentTypes().subscribe((response) => {
        if (response.length <= 0) {
          // NotificationUtilities.giveNotice('Failure', 'Unable to load appointment types from server. Please reload the page.', false);
        }
        this.appointmentTypes = response;
        // console.log(response);
      });
    }
  }
  toggleDisplayCanceled() {
    this.displayCanceled = !this.displayCanceled
  }
  toggleDisplayComplete() {
    this.displayComplete = !this.displayComplete
  }
  getAppointments() {

    this.isLoading = true;
    const year = new Date().getFullYear();
    this.appointmentService.getAppointments(year).subscribe((result) => {
      if(result == null) {
        // NotificationUtilities.giveNotice("Failure", 'There was an error loading the appointments. Please try refreshing the page.', false);
      } 
      else {
        this.appointments = result
      }

      if (this.viewingAppointmentId) {
        const a = this.appointments.find( a => a.appointmentId == this.viewingAppointmentId);
        if (a) {
          this.appointment = a;
          this.appointmentType = this.appointment?.appointmentType ?? null;
        }
      }
      this.isLoading = false;

    })
  }
  rescheduleAppointment() {
    if (this.appointmentPickerProperties.selectedTime == null || this.submittingReschedule || this.appointment === null) {
      return;
    }

    this.submittingReschedule = true;
    const appointment = this.appointment as Appointment
    const appointmentId = appointment.appointmentId;
    const appointmentTimeId = this.appointmentPickerProperties.selectedTime;

    this.appointmentService.rescheduleAppointment(appointmentId, appointmentTimeId)
    .subscribe((result: any) => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      
      if (result) {
        this.appointments.map(appt => appt.appointmentId === result.appointment.appointmentId ? 0 : result)
        this.appointment = result.appointment

        appointment.scheduledTime = result?.appointment?.appointment_time?.scheduledTimePretty;
        appointment.title = result?.appointment?.appointment_time.site.title; //this.appointmentPickerProperties.selectedSite;
        appointment.appointmentType = this.appointmentType;

        // Clear the selected values
        this.appointmentPickerProperties.selectedDate = null;
        this.appointmentPickerProperties.selectedSite = null;
        this.appointmentPickerProperties.time = null;

        this.resetAppointmentProperties(appointment);

        this.submittingReschedule = false;
        
        // Let the user know it was successful
        // NotificationUtilities.giveNotice("Success!", "This appointment was successfully rescheduled.");
      } else {
        this.submittingReschedule = false;

        // Let the user know it failed
        // NotificationUtilities.giveNotice("Failure", "Something went wrong and this appointment was not rescheduled!", false);
      }
    })
  }

  resetAppointmentProperties(appointment: Appointment) {
    // Reset the status properties on the appointment
    appointment.cancelled = false;
    appointment.completed = false;
    appointment.started = false;
    appointment.incomplete = false;
    appointment.inProgress = false;
    appointment.statusText = "Not Started";

    // Reset times on the appointment
    appointment.timeIn = null;
    appointment.timeReturnedPapers = null;
    appointment.timeAppointmentStarted = null;
    appointment.timeAppointmentEnded = null;
  }

  selectAppointment(appointment:Appointment | null) {		
    
    this.router.navigate(['management', 'appointments', appointment?.appointmentId]);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.appointment = appointment;
    this.appointmentType = this.appointment?.appointmentType ?? null;
    return;
    this.appointment = appointment;
    console.log('appointment', this.appointment)
    // appointmentNotesAreaSharedProperties.appointmentId = appointment.appointmentId;  // Need to share the appointment id so we can load/add notes
    this.appointmentType = appointment?.appointmentType ?? null;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  deselectAppointment() {
    this.router.navigate(['management', 'appointments']);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.appointment = null
  }
  openCancelling() {
    if (this.appointment?.appointmentId != undefined) { // this should be unecessary as there is no way to get unless appt isn't undefined. i don't like TS. 
      this.modalService.open(CancelAppointment, {appointment: this.appointment});
    }
  }

  nullSettings(): boolean {
    return this.appointmentPickerProperties.selectedTime? true : false
  }

  closeCancelling() {
    this.modalService.close();
   }
  
  filteredAppointments(): Appointment[] {
    var appts = this.appointments
    
    if (this.appointmentSearch){
      var searchString = this.appointmentSearch.toLowerCase();
      appts = appts
        .filter(appt => {
            return appt.client?.firstName?.toLowerCase().includes(searchString) ||
            appt.client?.lastName?.toLowerCase().includes(searchString) ||
            appt.client?.emailAddress?.toLowerCase().includes(searchString)
          })
    } 
    if (this.appointmentSearchSite){
      var searchString = this.appointmentSearchSite.toLowerCase();
      appts = appts
        .filter(appt => {
            return appt.site.title.toLowerCase().includes(searchString)
          })
    } 
    if (this.appointmentSearchTranslator){
      var searchString = this.appointmentSearchTranslator;
      appts = appts
        .filter(appt => {
            if (searchString == 'No')
              return appt.answersByLookup?.translator?.answer == 'No';
            else
              return appt.answersByLookup?.translator?.answer != 'No';
          })
    } 
    
    if (this.displayCanceled && this.displayComplete){
      appts = appts
    } 
    if (this.displayCanceled) {
      appts = appts
        .filter(((appointment) => appointment.progressionStepName != 'Complete'))
    }
    else if (this.displayComplete) {
      appts = appts
        .filter(((appointment) => appointment.progressionStepName != 'Canceled'))
    }
    else {
      appts = appts
        .filter(((appointment) => appointment.progressionStepName != 'Complete' && appointment.progressionStepName != 'Canceled' ))
    }

    return appts.sort((a, b) => {
        return a.appointment_time.scheduledTime > b.appointment_time.scheduledTime ? 1 : -1;
      });
   }
}
